import { render, staticRenderFns } from "./OldWoononOrderShowDetailsCard.vue?vue&type=template&id=61b1e811"
import script from "./OldWoononOrderShowDetailsCard.vue?vue&type=script&lang=ts"
export * from "./OldWoononOrderShowDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports